export default __webpack_public_path__ + "dcc61339c71917c1f9e99989ce1700ca.png";